import React from 'react';
import { Avatar } from 'material-ui';
import { connect } from 'react-redux';
import _ from 'lodash';
import classNames from 'classnames';
import moment from 'moment';
import { injectIntl } from 'react-intl';
import ReactTooltip from 'react-tooltip';
import Icon from '@material-ui/core/Icon';
import SvgIcon from '@material-ui/core/SvgIcon';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import NavigationExpandMoreIcon from 'material-ui/svg-icons/navigation/expand-more';
import MenuItem from 'material-ui/MenuItem';
import async from 'async';
import Translate from 'translate';
import AssignFileModal from 'routes/app/components/Agent/AssignFileModal/';
import SearchIncmsModal from 'routes/app/components/Agent/SearchIncmsModal/';
import SearchComplaintModal from 'routes/app/components/Agent/SearchComplaintModal/';
import SearchComplaintLECModal from 'routes/app/components/Agent/SearchComplaintLECModal/';
import SendEmailModal from 'routes/app/components/Agent/SendEmailModal';
import AddContactModal from 'routes/app/components/Agent/AddContactModal/';
import AddRccsModal from 'routes/app/components/Agent/AddRccsModal/';
import CheckImsModal from 'routes/app/components/Agent/CheckImsModal/';
import CheckImsLECModal from 'routes/app/components/Agent/CheckImsLECModal/';
import CheckImsAPUModal from 'routes/app/components/Agent/CheckImsAPUModal/';
import AssignCaseModal from 'routes/app/components/Agent/AssignCaseModal/';
import CaseDetailModal from 'routes/app/components/Agent/CaseDetailModal/';
import AddImsModal from 'routes/app/components/Agent/AddImsModal/';
import AddImsAPUModal from 'routes/app/components/Agent/AddImsAPUModal/';
import AddImsLECModal from 'routes/app/components/Agent/AddImsLECModal/';
import DeleteModal from 'components/HTMLElements/DeleteModal';
import IncmsService from 'services/IncmsService';
import ChannelService from 'services/ChannelService';
import ChannelCaseService from 'services/ChannelCaseService';
import { Text, Select } from 'components/FormElements/';
import { toggleAlertError, toggleLoading, setActiveAccount } from 'stores/actions/';

class ProfileTab extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      activeAccount: _.find( _.get( props, 'channel.accounts', [] ), { active: true } ) || {},
      addContactModalOpened: false,
      addImsModalOpened: false,
      checkImsModalOpened: false,
      addRccsModalOpened: false,
      assignCaseModalOpened: false,
      caseDetailModalOpened: false,
      data: { cases: [], profile: {} },
      imsData: [],
      extendedAccount: false,
      linkModalOpened: false,
      unlinkModalOpened: false,
      searchIncmsModalOpened: false,
      searchComplaintModalOpened: false,
      sendEmailModalOpened: false,
      assignFileModalOpened: false,
      showLink: true,
    };

    this.channel = props.channel;
    this.getData = this.getData.bind( this );
    this.linkCustomer = this.linkCustomer.bind( this );
    this.linkCase = this.linkCase.bind( this );
    this.unlink = this.unlink.bind( this );
    this.onChangeProfile = this.onChangeProfile.bind( this );
    this.reloadCaseData = this.reloadCaseData.bind( this );
    this.reloadOnChangeProfile = this.reloadOnChangeProfile.bind( this );
    this.toggleAddContactModal = this.toggleAddContactModal.bind( this );
    this.toggleAddImsModal = this.toggleAddImsModal.bind( this );
    this.toggleAddRccsModal = this.toggleAddRccsModal.bind( this );
    this.toggleAssignCaseModal = this.toggleAssignCaseModal.bind( this );
    this.toggleCaseDetailModal = this.toggleCaseDetailModal.bind( this );
    this.toggleLinkModal = this.toggleLinkModal.bind( this );
    this.toggleUnLinkModal = this.toggleUnLinkModal.bind( this );
    this.toggleSearchIncmsModal = this.toggleSearchIncmsModal.bind( this );
    this.toggleSearchComplaintModal = this.toggleSearchComplaintModal.bind( this );
    this.toggleAssignFileModal = this.toggleAssignFileModal.bind(this);
  }

  componentDidMount() {
    this.getData( false, true )
  }

  componentWillReceiveProps( nextProps ) {
    if ( nextProps.channel.id !== this.channel.id ) {
      this.channel = nextProps.channel;
      this.setState( {
        showLink: true,
        activeAccount: _.find( _.get( nextProps, 'channel.accounts', [] ), { active: true } ) || {},
        accounts: false
      }, () => this.getData() );
    }
  }

  getData( cb, firstLoad ) {
    
    if ( !this.state.activeAccount.id ) return this.setState( {
      data: {
        cases: [],
        profile: {}
      }
    } );

    if ( !cb ) this.props.toggleLoading( true );

    async.waterfall([
      this.getRcss,
      this.getIms,
    ], (error, results)=> {
      if( cb ) {
        if( error ) return cb( error );
        else return cb( null, { data: results.data, imsData: results.imsData } );
      }

      this.props.toggleLoading( false );
      if( !error ) {
        this.props.setActiveAccount( results.data.profile );
        this.setState( { data: results.data, imsData: results.imsData }, () => firstLoad ? {} : this.props.onReloadActiveChannel( false ) )
      } else {
        if( results && results.data ) {
          this.props.setActiveAccount( results.data.profile );
          this.setState( { data: results.data }, () => firstLoad ? {} : this.props.onReloadActiveChannel( false ) )
        }
      }
    } );
  }

  getRcss = ( cb ) => {
    ChannelService.getChannelCases( this.channel.id, this.state.activeAccount.id, { 'sortby[createdAt]': 'DESC' } )
      .then( ( response ) => {cb( response.errors, response.data )} )
  };

  getIms = ( data, cb ) => {
    
    const {externalCustomer} = this.props;
    
    if( !this.props.imsDomainActive ) return cb( null, { data } );

    if (externalCustomer === 'lec' || externalCustomer === 'escom') {
      IncmsService.getOutages( this.state.activeAccount.account )
        .then( response => {
          if( response.errors ) {
            this.props.toggleAlertError( `IMS: ${response.errors}` );
            return cb( null, { data } );
          }
          else {
            return cb( null, { data, imsData: response.data } )
          }
        } )

    } else {
      ChannelCaseService.checkIms( this.state.activeAccount.account )
        .then( response => {
          if( response.errors ) {
            this.props.toggleAlertError( `IMS: ${response.errors}` );
            return cb( null, { data } );
          }
          else {
            return cb( null, { data, imsData: response.data } )
          }
        } )
    }
  };

  getImsLEC = ( data, cb ) => {
    if( !this.props.imsDomainActive ) return cb( null, { data } );
    ChannelCaseService.checkImsLEC( this.state.activeAccount.account )
      .then( response => {
        if( response.errors ) {
          this.props.toggleAlertError( `IMS: ${response.errors}` );
          return cb( null, { data } );
        }
        else {
          return cb( null, { data, imsData: response.data } )
        }
      } )
  };

  linkCustomer() {
    const { channel, toggleAlertError, toggleLoading } = this.props;
    toggleLoading( true );

    IncmsService.linkCustomer( channel.id, { account: this.state.activeAccount.id } )
      .then( ( response ) => {
        toggleLoading( false );
        if ( response.errors ) return toggleAlertError( response.errors );

        this.setState( { linkModalOpened: !this.state.linkModalOpened, showLink: true  }, this.getData );
      } );
  }

  unlink() {
    const { channel, toggleAlertError, toggleLoading, onReloadData } = this.props;
    toggleLoading( true );

    IncmsService.unLink( channel.id, { account: this.unlinkSelectedAccount.id } )
      .then( ( response ) => {
        toggleLoading( false );
        if ( response.errors ) toggleAlertError( response.errors );
        // this.reloadCaseData( response.data );
        
        this.setState( { unlinkModalOpened: !this.state.unlinkModalOpened, showLink: false },  onReloadData(channel.id) );
      } );
  }

  linkCase( id ) {
    const { toggleAlertError, toggleLoading } = this.props;
    toggleLoading( true );

    ChannelCaseService.linkRccs( id ).then( ( response ) => {
      toggleLoading( false );
      if ( response.errors ) toggleAlertError( response.errors );

      this.reloadCaseData( response.data );
      this.setState( { linkModalOpened: !this.state.linkModalOpened } );
    } );
  }

  onChangeProfile( profile ) {
    this.props.toggleLoading( true );

    let dataToSend = {
      "idAccount": profile.idAccount,
      "account": profile.account,
      "idCustomer": profile.idCustomer,
      "incmsDataobj": JSON.stringify( profile ),
      "channel": this.props.channel.id
    };
    ChannelService.saveChannelAccount( dataToSend ).then( response => {
      if ( response.data ){
        const data =  response.data;
        data.incmsDataobj = profile;
        return this.setState( {
          activeAccount: data,
          accounts: true,
          showLink: true, 
        }, this.reloadOnChangeProfile );
      }

      this.props.toggleLoading( false );
    } );
  }

  reloadOnChangeProfile() {
    const { channel, onReloadData, onReloadActiveChannel, setActiveAccount, toggleLoading } = this.props;

    async.parallel( {
      channel: onReloadData.bind( this, channel.id ),
      data: this.getData
    }, ( error, results ) => {
      toggleLoading( false );

      if ( !error ) {
        if( _.get( results, 'data.data.profile' ) )
          setActiveAccount( results.data.data.profile );
        this.setState( { data: results.data ? results.data.data : {} }, () => onReloadActiveChannel( results.channel ) )
      }
    } )
  }

  reloadCaseData( item ) {
    const cases = _.cloneDeep( this.state.data.cases );
    const caseIndex = _.findIndex( cases, { id: item.id } );

    if ( caseIndex !== -1 ) {
      cases[caseIndex] = item;
      this.setState( { data: { ...this.state.data, cases } } );
    }
  }



  searchComplaint( data ) {

    if ( (this.props.externalCustomer === 'lec') || (this.props.externalCustomer === 'apu') || (this.props.externalCustomer === 'escom')){
      this.imsInfo = data
      this.toggleCheckImsModal();

    }
    else {
      this.props.toggleLoading( true );
      IncmsService.searchComplaint( data.complaintNumber ).then( ( response ) => {
        //if ( response.data ) this.setState( { data: response.data, submitted: true } );
        //else this.setState( { submitted: true } );
        if ( response.data )
          this.imsInfo = response.data
        this.toggleCheckImsModal();
        this.props.toggleLoading( false );
        
      } )
    }

  }

  toggleAddContactModal() {
    this.setState( { addContactModalOpened: !this.state.addContactModalOpened } )
  }

  toggleAddImsModal() {
    this.setState( { addImsModalOpened: !this.state.addImsModalOpened } )
  }

  toggleCheckImsModal = () => {
    this.setState( { checkImsModalOpened: !this.state.checkImsModalOpened } )
  };

  toggleAddRccsModal() {
    this.setState( { addRccsModalOpened: !this.state.addRccsModalOpened } )
  }

  toggleAssignCaseModal( item ) {
    this.caseToAssign = item;
    this.setState( { assignCaseModalOpened: !this.state.assignCaseModalOpened } )
  }

  toggleCaseDetailModal( item ) {
    this.caseDetail = item;
    this.setState( { caseDetailModalOpened: !this.state.caseDetailModalOpened } )
  }

  toggleLinkModal( cb, item ) {
    this.linkFn = cb;
    this.caseToLink = item;
    this.setState( { linkModalOpened: !this.state.linkModalOpened } )
  };
  toggleUnLinkModal( cb, item ) {
    // this.unlinkFn = cb;
    // this.caseToLink = item;
    this.setState( { unlinkModalOpened: !this.state.unlinkModalOpened } )
  };
  toggleSearchIncmsModal() {
    this.setState( { searchIncmsModalOpened: !this.state.searchIncmsModalOpened } )
  }

  toggleSearchComplaintModal() {
    this.setState( { searchComplaintModalOpened: !this.state.searchComplaintModalOpened } )
  }

  toggleSendEmailModal = () => {
    this.setState( { sendEmailModalOpened: !this.state.sendEmailModalOpened } )
  };

  toggleAssignFileModal() {
    this.setState({
     assignFileModalOpened: !this.state.assignFileModalOpened
    });
  };
  renderCaseStatus( status ) {
    const { intl } = this.props;
    switch( status ) {
      case 'created':
        return <i className="fa fa-flag" data-tip={intl.formatMessage( { id: status } )}/>;
      case 'in_progress':
        return <i className="fa fa-play" data-tip={intl.formatMessage( { id: status } )}/>;
      case 'solved':
        return <i className="fa fa-check" data-tip={intl.formatMessage( { id: status } )}/>;
      case 'block':
        return <i className="fa fa-ban" data-tip={intl.formatMessage( { id: status } )}/>
    }
  }

  renderImsStatus( status ) {
    const { intl } = this.props;
    switch( status ) {
      case 'Created':
        return <i className="fa fa-flag" data-tip={intl.formatMessage( { id: status } )}/>;
      case 'Creada':
          return <i className="fa fa-flag" data-tip={intl.formatMessage( { id: status } )}/>;
      case 'In Progress':
        return <i className="fa fa-play" data-tip={intl.formatMessage( { id: status } )}/>;
      case 'En tratamiento':
          return <i className="fa fa-play" data-tip={intl.formatMessage( { id: status } )}/>;
      case 'Resolved':
        return <i className="fa fa-check" data-tip={intl.formatMessage( { id: status } )}/>;
      case 'Resuelta':
          return <i className="fa fa-check" data-tip={intl.formatMessage( { id: status } )}/>;
    }
  }

  render() {
    const { channel, onReloadData, intl, imsDomainActive, externalCustomer, dateFormat } = this.props;
    const {
      activeAccount, addContactModalOpened, addImsModalOpened, addRccsModalOpened, caseDetailModalOpened, data, imsData,
      extendedAccount, linkModalOpened, unlinkModalOpened, searchIncmsModalOpened, assignCaseModalOpened, checkImsModalOpened,
      sendEmailModalOpened, assignFileModalOpened, showLink, searchComplaintModalOpened
    } = this.state;
    const accounts = _.filter( _.get( channel, 'accounts', [] ), { active: true } );
    const isClosed = channel.status === 'closed';
    const channelNotEnabled = channel.status !== 'open' && channel.status !== 'in_progress' && channel.status !== 'return';
    return (
      <div className="profile-tab p-3">
        <div className="row">
          <div className="col-md-auto pr-0">
            <Avatar src={channel.webPathThumbnail}/>
          </div>
          <div className="col-md pr-0">
            <div className="row">
              <div className="col-md">
                <p className="m-0" style={{lineHeight: 1}}>{channel.name} </p>
                {channel.type === 'facebook' && <span className="text-small color-gray-4">{channel.faceId}</span>}
                {channel.type === 'twitter' && <span className="text-small color-gray-4">{channel.twId}</span>}
                <span className="text-small text-info d-block">{channel.email}</span>
              </div>
            </div>
            {!isClosed &&
            <div className="row mt-1">
              <div className="col-md">
                <i data-tip={intl.formatMessage( { id: "SearchForAccount" } )}
                   className={classNames( 'icon-search pointer py-1 pr-1', {
                     'color-purple': !channelNotEnabled,
                     'color-gray-3': channelNotEnabled
                   } )}
                   onClick={channelNotEnabled ? () => {} : this.toggleSearchIncmsModal}
                >
                  <ReactTooltip id="tooltip-1" place="bottom" type="dark" effect="solid"/>
                </i>
                <i data-tip={intl.formatMessage( { id: "SendEmail" } )}
                   className={classNames( 'icon-email pointer p-1', {
                     'color-purple': !channelNotEnabled,
                     'color-gray-3': channelNotEnabled
                   } )}
                   onClick={channelNotEnabled ? () => {} : this.toggleSendEmailModal}
                >
                  <ReactTooltip id="tooltip-2" place="bottom" type="dark" effect="solid"/>
                </i>

                {!_.isEmpty( activeAccount )  && (showLink) &&
                <i data-tip={intl.formatMessage( { id: "link" } )} className={classNames( 'icon-link pointer p-1' , {
                  'color-purple': !data.profile.idSocialAccount && !channelNotEnabled,
                  'color-gray-3': data.profile.idSocialAccount || channelNotEnabled
                } )}
                   onClick={data.profile.idSocialAccount || channelNotEnabled ? () => {} : () => this.toggleLinkModal( this.linkCustomer )}
                >
                  <ReactTooltip id="tooltip-3" place="bottom" type="dark" effect="solid"/>
                </i>
                }

                {!_.isEmpty( activeAccount ) && (showLink) &&
               
                  <IconMenu
                            iconButtonElement={
                              <IconButton touch className="btn-account">
                                <Icon  style={{ height: '20px' }}>
                                <i data-tip={intl.formatMessage( { id:"unLink" } )} style={{ marginLeft: '0em', fontSize:'1.1rem' }}  className={classNames( 'icon-unlink pointer' , {
                                  'color-purple': !channelNotEnabled,
                                  'color-gray-3': channelNotEnabled
                                } )}
                                  
                                >
                                  <ReactTooltip id="tooltip-3" place="bottom" type="dark" effect="solid"/>
                                </i>                                
                              </Icon>
                                
                              </IconButton>
                            }>
                    {_.map( accounts, ( account, index ) =>
                      <MenuItem
                        onClick={ channelNotEnabled ? () => {} : () => { this.unlinkSelectedAccount =  account; this.toggleUnLinkModal( this.unlink ) } }
                        key={index}
                        style={{ lineHeight: '25px', fontSize: '14px', minHeight: 'unset' }}
                        primaryText={account.account}/>
                    )}
                  </IconMenu>

           
                }

                {  externalCustomer !== 'apu' &&
                  <i data-tip={intl.formatMessage( { id: "searchComplaint" } )}
                    className={classNames( 'fa fa-flash pointer p-2 ', {
                      'color-gray-3': channelNotEnabled,
                      'color-purple': !channelNotEnabled
                    } )}
                    onClick={channelNotEnabled ? () => {} : this.toggleSearchComplaintModal}
                  >
                    <ReactTooltip id="tooltip-2" place="bottom" type="dark" effect="solid"/>
                  </i>
                }
                

              </div>
            </div>
            }
          </div>
        </div>

        {(!!accounts.length || this.state.accounts) && (showLink) &&
        <div>
          <div className="row mt-1">
            <div className="col-md pl-0">
              <hr className="mt-2 mb-1"/>
            </div>
          </div>

          <div className="row my-1">
            <div className="col-md-5">
              <img src="assets/images/onesite_logo.png" className="img-fluid"/>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 font-weight-light"><Translate id="name"/></div>
            <div className="col-md-7 pr-0 text-small font-weight-light text-gray-4">{data.profile.fullName}</div>
            <div className="col-md-2 d-flex align-items-center justify-content-end">
              <i className={classNames( 'fa pointer', {
                'fa-minus': extendedAccount,
                'fa-plus': !extendedAccount,
              } )} onClick={() => this.setState( { extendedAccount: !extendedAccount } )}/>
              <IconMenu style={{ height: '20px' }}
                        iconButtonElement={
                          <IconButton touch className="btn-account">
                            <NavigationExpandMoreIcon/>
                          </IconButton>
                        }>
                {_.map( accounts, ( account, index ) =>
                  <MenuItem
                    onClick={() => {
                      if( activeAccount.account !== account.account ) {
                        this.setState( { activeAccount: account }, this.getData)
                      }
                    } }
                    key={index}
                    style={{ lineHeight: '25px', fontSize: '14px', minHeight: 'unset' }}
                    primaryText={account.account}/>
                )}
              </IconMenu>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 font-weight-light"><Translate id="account"/></div>
            <div className="col-md-9 text-small font-weight-light text-gray-4">{activeAccount.account || '---'}</div>
          </div>
          <div className="row">
            <div className="col-md-3 font-weight-light"><Translate id="email"/></div>
            <div className="col-md-9 text-small font-weight-light text-gray-4">{data.profile.email || '---'}</div>
          </div>
          {extendedAccount &&
          <div>
            <div className="row">
              <div className="col-md-3 font-weight-light"><Translate id="phone"/></div>
              <div className="col-md-9 text-small font-weight-light text-gray-4">{data.profile.phone || '---'}</div>
            </div>
            <div className="row">
              <div className="col-md-3 font-weight-light"><Translate id="location"/></div>
              <div
                className="col-md-9 text-small font-weight-light text-gray-4">{data.profile.location || '---'}</div>
            </div>
            <div className="row">
              <div className="col-md-3 font-weight-light"><Translate id="doc"/></div>
              <div className="col-md-9 text-small font-weight-light text-gray-4">
                {data.profile.docNumber ? `#${data.profile.docNumber}` : '---'}
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 font-weight-light"><Translate id="supply"/></div>
              <div className="col-md-9 text-small font-weight-light text-gray-4">
                {data.profile.supplyNumber ? `#${data.profile.supplyNumber}` : '---'}
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 font-weight-light"><Translate id="meter"/></div>
              <div className="col-md-9 text-small font-weight-light text-gray-4">
                {data.profile.meterNumber ? `#${data.profile.meterNumber}` : '---'}
              </div>
            </div>
          </div>
          }

          <hr className="mt-3 mb-1" style={{borderWidth: '2px'}}/>

          <div className="row my-2">
            <div className="col-md-12 d-flex justify-content-between align-items-center">
              <h5 className="m-0"><Translate id="incmsCases"/></h5>
              {!channelNotEnabled &&
              <div className={classNames( 'font-weight-light', {
                'color-purple pointer': data.profile.idSocialAccount,
                'color-gray-4': !data.profile.idSocialAccount
              } )}
                   onClick={data.profile.idSocialAccount ? this.toggleAddRccsModal : () => {}}>
                <i className="icon-plus text-small mr-2"/> <Translate id="RCCS"/>
              </div>
              }
            </div>
          </div>

          <hr className="m-1"/>

          <div className="cases-list">
            {_.map( data.cases, ( item, index ) =>
              <div key={index} onClick={() => this.toggleCaseDetailModal( item )} className="pointer">
                <div className="d-flex my-1">
                  <div className="col-md-auto text-normal pl-0">{this.renderCaseStatus( item.status )}</div>
                  <ReactTooltip place="bottom" type="dark" effect="solid"/>
                  <div className="col-md pl-0 color-gray-2">
                    <div>
                      {item.typeCase === 'rccs' && item.rccsReference}
                      {item.typeCase === 'contact' && item.rccsReference}
                    </div>
                    <div className="text-small color-gray-5 font-weight-light">
                      { ( externalCustomer == 'apu'  && item.CreationDate ) ?
                        moment( item.CreationDate ).format( `${dateFormat}` ) :
                        moment( item.registerDate ).format( `${dateFormat}` )
                      } 
                  </div>
                  </div>

                  <div className="col-md-auto pl-0">
                    {item.typeCase === 'rccs' && !item.rccsLink && !isClosed && data.profile.idSocialAccount &&
                    <i className="icon-link" onClick={( e ) => {
                      e.stopPropagation();
                      this.toggleLinkModal( () => this.linkCase( item.id ), item )
                    }}/>
                    }

                    {(item.typeCase === 'rccs' && item.status !== 'solved' && !isClosed && externalCustomer !=='lec' && externalCustomer !=='escom'&& externalCustomer !=='apu') &&
                    <i className="icon-add-user" onClick={( e ) => {
                      e.stopPropagation();
                      this.toggleAssignCaseModal( item )
                    }}/>
                    }

                    {(item.typeCase === 'rccs' && !isClosed && (externalCustomer ==='lec' || externalCustomer ==='escom')) &&
                    <i className="icon-add-user color-gray-5" onClick={( e ) => {
                      e.stopPropagation();
                     }}/>
                    }
                  </div>
                </div>

                {index < data.cases.length - 1 && <hr className="my-1"/>}
              </div>
            )}
          </div>

          <hr className="m-0" style={{borderWidth: '2px'}}/>

          {!!imsDomainActive &&
          <div>
            <div className="row my-2">
              <div className="col-md-12 d-flex justify-content-between align-items-center">
                <h5 className="m-0"><Translate id={ (externalCustomer === 'lec' || externalCustomer === 'escom')? 'Outages' : 'imsIncidences' }/></h5>
                {!channelNotEnabled &&
                <div
                  className={ classNames( 'font-weight-light', {
                    'color-purple pointer': data.profile.idSocialAccount,
                    'color-gray-4': !data.profile.idSocialAccount
                    } ) }
                    onClick={ data.profile.idSocialAccount ? this.toggleAddImsModal : () => {} }>
                  <i className="icon-plus text-small mr-2"/><Translate id={ (externalCustomer === 'lec' || externalCustomer === 'escom')? 'Outage' : 'INCIDENCE' }/>
                </div>
                }
              </div>
            </div>

            <hr className="m-1"/>

            <div className="cases-list">
              {( externalCustomer !== 'apu' && imsData ) ? _.map( imsData, ( item, index ) =>
                <div key={index} onClick={() => {this.searchComplaint(item);}} className="pointer">
                  <div className="d-flex my-1">
                    <div className="col-md-auto pl-0 text-normal">{this.renderImsStatus( item.status )}</div>
                    <ReactTooltip place="bottom" type="dark" effect="solid"/>
                    <div className="col-md pl-0 color-gray-2">
                      { ((externalCustomer !== 'lec' && externalCustomer !== 'escom') && item.complaintNumber ) ? `${item.complaintNumber.slice( 0, 35 )}${item.complaintNumber.length > 35 ? '...' : ''}` : ''}
                      { ((externalCustomer === 'lec' || externalCustomer === 'escom') && item.callLabel ) ? `${item.callLabel.slice( 0, 35 )}${item.callLabel.length > 35 ? '...' : ''}` : ''}
                    </div>
                    <div className="col-md-3 pl-0 text-small color-gray-5 font-weight-light">
                      { (externalCustomer === 'lec' || externalCustomer === 'escom')? item.date : item.creationDate }
                    </div>
                  </div>

                  <hr className="my-1"/>
                </div>
              ) : null }

              {( externalCustomer === 'apu' && imsData && imsData.outages ) ? _.map( imsData.outages, ( item, index ) =>
                <div key={index} onClick={() => {this.searchComplaint(item);}} className="pointer">
                  <div className="d-flex my-1">
                    <div className="col-md-auto pl-0 text-normal">{this.renderImsStatus( item.status )}</div>
                    <ReactTooltip place="bottom" type="dark" effect="solid"/>
                    <div className="col-md pl-0 color-gray-2">
                      { (externalCustomer === 'apu' && item.code ) ? `${item.code.slice( 0, 35 )}${item.code.length > 35 ? '...' : ''}` : ''}
                    </div>
                    <div className="col-md-3 pl-0 text-small color-gray-5 font-weight-light">
                      { moment( item.createDate ).format( 'DD/MM/YYYY' ) }
                    </div>
                  </div>

                  <hr className="my-1"/>
                </div>
              ) : null }
            </div>
          </div>
          }
        </div>
        }
        
        <SearchIncmsModal open={searchIncmsModalOpened}
                          channel={channel}
                          onClose={this.toggleSearchIncmsModal}
                          onSelectCard={this.onChangeProfile}
        />
        {(externalCustomer !== 'lec'  && externalCustomer !== 'escom' ) &&
        <SearchComplaintModal open={searchComplaintModalOpened}
                          onClose={this.toggleSearchComplaintModal}
                          onSelectCard={this.onChangeProfile}
        />
        }
        {(externalCustomer === 'lec' || externalCustomer === 'escom')&&
        <SearchComplaintLECModal open={searchComplaintModalOpened}
                          onClose={this.toggleSearchComplaintModal}
                          onSelectCard={this.onChangeProfile}
                          activeAccount={activeAccount}
        />
        }

        <SendEmailModal open={sendEmailModalOpened}
                        onClose={this.toggleSendEmailModal}
                        channel={channel}
                        activeAccount={activeAccount}
        />

        <AddContactModal channel={channel}
                         activeAccount={activeAccount}
                         open={addContactModalOpened}
                         onClose={this.toggleAddContactModal}
                         onReloadData={this.getData}
        />

        <AddRccsModal channel={channel}
                      activeAccount={activeAccount}
                      open={addRccsModalOpened}
                      onClose={this.toggleAddRccsModal}
                      onReloadData={this.getData}
        />

        {(!!imsDomainActive && externalCustomer !== 'lec'  && externalCustomer !== 'escom' && externalCustomer !== 'apu'  ) &&
        <AddImsModal channel={channel}
                     activeAccount={activeAccount}
                     open={addImsModalOpened}
                     onClose={this.toggleAddImsModal}
                     onReloadData={onReloadData}
        />
        }
        {(!!imsDomainActive && externalCustomer === 'apu'  ) &&
        <AddImsAPUModal channel={channel}
                     activeAccount={activeAccount}
                     open={addImsModalOpened}
                     onClose={this.toggleAddImsModal}
                     onReloadData={onReloadData}
        />
        }
        {(!!imsDomainActive && (externalCustomer === 'lec' || externalCustomer === 'escom') ) &&
        <AddImsLECModal channel={channel}
                     activeAccount={activeAccount}
                     open={addImsModalOpened}
                     onClose={this.toggleAddImsModal}
                     onReloadData={onReloadData}
        />
        }

        <AssignFileModal
          open={assignFileModalOpened}
          onClose={this.toggleAssignFileModal}
          onSelectCard={this.onChangeProfile}
        />

        {( externalCustomer !== 'lec' && externalCustomer !== 'escom' && externalCustomer !== 'apu' ) &&
        <CheckImsModal data={this.imsInfo || {}}
                       open={checkImsModalOpened}
                       onClose={this.toggleCheckImsModal}
        />
        }

        {(externalCustomer === 'lec' || externalCustomer === 'escom') &&
        <CheckImsLECModal data={this.imsInfo || {}}
                       open={checkImsModalOpened}
                       onClose={this.toggleCheckImsModal}
        />
        }

        {( externalCustomer === 'apu'  ) &&
        <CheckImsAPUModal data={this.imsInfo || {}}
                       open={checkImsModalOpened}
                       onClose={this.toggleCheckImsModal}
        />
        }

        <AssignCaseModal open={assignCaseModalOpened}
                         case={this.caseToAssign}
                         onReloadData={this.reloadCaseData}
                         onClose={this.toggleAssignCaseModal}
        />

        <CaseDetailModal open={caseDetailModalOpened}
                         case={this.caseDetail}
                         onClose={this.toggleCaseDetailModal}
        />

        <DeleteModal onConfirm={this.linkFn}
                     label={this.caseToLink ?
                       <span>
                         <Translate id="areYouSureLink"/> {this.caseToLink.registerComment || ""}?
                       </span>
                       :
                       <span>
                         <Translate id="areYouSureLinkAccount"/> #{activeAccount.account || ""}?
                       </span>
                     }
                     opened={linkModalOpened}
                     onToggle={this.toggleLinkModal}
        />

        <DeleteModal onConfirm={this.unlink}
                     label={this.caseToLink ?
                       <span>
                         <Translate id="areYouSureUnLink"/> {this.caseToLink.registerComment || ""}?
                       </span>
                       :
                       <span>
                         <Translate id="areYouSureUnLinkAccount"/> #{ this.unlinkSelectedAccount ? this.unlinkSelectedAccount.account : ''}?
                       </span>
                     }
                     opened={unlinkModalOpened}
                     onToggle={this.toggleUnLinkModal}
        />
      </div>
    )
  }
}

const mapStateToProps = ( state ) => ({
  imsDomainActive: state.settings.imsDomainActive,
  externalCodes: state.settings.externalCodes,
  externalCustomer: state.settings.externalCustomer,
  dateFormat: state.settings.dateFormat,
});

const mapDispatchToProps = dispatch => ({
  setActiveAccount: ( account ) => dispatch( setActiveAccount( account ) ),
  toggleAlertError: ( message ) => dispatch( toggleAlertError( message ) ),
  toggleLoading: ( isLoading ) => dispatch( toggleLoading( isLoading ) ),
});

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( injectIntl( ProfileTab ) );




// WEBPACK FOOTER //
// ./routes/app/components/Agent/ProfileTab/index.js